;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"12dc34fdf9bd5bfc2cafe7cd0dd30dfe85634448"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { initSentry } from "./sentry.config"
import {
  browserTracingIntegration,
  browserProfilingIntegration,
  thirdPartyErrorFilterIntegration,
} from "@sentry/nextjs"

initSentry({
  integrations: [
    browserTracingIntegration(),
    browserProfilingIntegration(),
    thirdPartyErrorFilterIntegration({
      behaviour: "drop-error-if-contains-third-party-frames",
      filterKeys: ["paragraph-nextjs"],
    }),
  ],
  tracePropagationTargets: ["paragraph.com/api", "api.paragraph.com"],
})
